var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23223 1.56524C3.70107 1.0964 4.33696 0.833008 5 0.833008H11.6667C11.8877 0.833008 12.0996 0.920805 12.2559 1.07709L17.2559 6.07709C17.4122 6.23337 17.5 6.44533 17.5 6.66634V16.6663C17.5 17.3294 17.2366 17.9653 16.7678 18.4341C16.2989 18.9029 15.663 19.1663 15 19.1663H5C4.33696 19.1663 3.70107 18.9029 3.23223 18.4341C2.76339 17.9653 2.5 17.3294 2.5 16.6663V3.33301C2.5 2.66997 2.76339 2.03408 3.23223 1.56524ZM5 2.49967C4.77899 2.49967 4.56702 2.58747 4.41074 2.74375C4.25446 2.90003 4.16667 3.11199 4.16667 3.33301V16.6663C4.16667 16.8874 4.25446 17.0993 4.41074 17.2556C4.56702 17.4119 4.77899 17.4997 5 17.4997H15C15.221 17.4997 15.433 17.4119 15.5893 17.2556C15.7455 17.0993 15.8333 16.8874 15.8333 16.6663V7.01152L11.3215 2.49967H5Z",
    fill: "#82858D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6663 0.833008C12.1266 0.833008 12.4997 1.2061 12.4997 1.66634V5.83301H16.6663C17.1266 5.83301 17.4997 6.2061 17.4997 6.66634C17.4997 7.12658 17.1266 7.49967 16.6663 7.49967H11.6663C11.2061 7.49967 10.833 7.12658 10.833 6.66634V1.66634C10.833 1.2061 11.2061 0.833008 11.6663 0.833008Z",
    fill: "#82858D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83301 10.8333C5.83301 10.3731 6.2061 10 6.66634 10H13.333C13.7932 10 14.1663 10.3731 14.1663 10.8333C14.1663 11.2936 13.7932 11.6667 13.333 11.6667H6.66634C6.2061 11.6667 5.83301 11.2936 5.83301 10.8333Z",
    fill: "#82858D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83301 14.1663C5.83301 13.7061 6.2061 13.333 6.66634 13.333H13.333C13.7932 13.333 14.1663 13.7061 14.1663 14.1663C14.1663 14.6266 13.7932 14.9997 13.333 14.9997H6.66634C6.2061 14.9997 5.83301 14.6266 5.83301 14.1663Z",
    fill: "#82858D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83301 7.50033C5.83301 7.04009 6.2061 6.66699 6.66634 6.66699H8.33301C8.79325 6.66699 9.16634 7.04009 9.16634 7.50033C9.16634 7.96056 8.79325 8.33366 8.33301 8.33366H6.66634C6.2061 8.33366 5.83301 7.96056 5.83301 7.50033Z",
    fill: "#82858D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.471f26fee983ba5bb7b83da90e4fb9d2.svg";
export { ForwardRef as ReactComponent };